'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _utils = require('helpers/utils');

var _Checkbox = require('components/Checkbox/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./GroupContactsListItem.scss');

var GroupContactsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(GroupContactsListItem, _PureComponent);

  function GroupContactsListItem() {
    (0, _classCallCheck3.default)(this, GroupContactsListItem);
    return (0, _possibleConstructorReturn3.default)(this, (GroupContactsListItem.__proto__ || (0, _getPrototypeOf2.default)(GroupContactsListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(GroupContactsListItem, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          onClick = _props.onClick,
          contact = _props.contact;

      onClick(contact);
    }
  }, {
    key: 'onDelete',
    value: function onDelete(e) {
      (0, _utils.stopEvent)(e);
      var _props2 = this.props,
          onDelete = _props2.onDelete,
          contact = _props2.contact;

      onDelete(contact);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          contact = _props3.contact,
          checked = _props3.checked;
      var t = this.context.t;


      return _react2.default.createElement(
        _ListItem2.default,
        {
          fullWidth: true,
          onClick: this.onClick,
          className: (0, _bind2.default)(className, styles.row)
        },
        _react2.default.createElement(
          'div',
          { className: styles.checkCell },
          _react2.default.createElement(_Checkbox2.default, {
            checked: checked,
            onClick: _utils.stopEvent,
            small: true
          })
        ),
        _react2.default.createElement(
          'div',
          null,
          contact.fullName
        ),
        _react2.default.createElement(
          'div',
          null,
          contact.email
        ),
        _react2.default.createElement(
          'div',
          { className: styles.actionCell },
          _react2.default.createElement(
            _Button2.default,
            { className: 'btn-icon', onClick: this.onDelete },
            _react2.default.createElement(
              'span',
              null,
              t('Delete')
            ),
            _react2.default.createElement('i', { className: 'icon-delete' })
          )
        )
      );
    }
  }]);
  return GroupContactsListItem;
}(_react.PureComponent), _class2.propTypes = {
  checked: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  contact: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onDelete: _propTypes2.default.func
}, _class2.defaultProps = {
  contact: {},
  onClick: _noop3.default,
  onDelete: _noop3.default
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDelete'), _class.prototype)), _class);
exports.default = GroupContactsListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupContacts/GroupContactsListItem/GroupContactsListItem.js
// module id = 2016
// module chunks = 1